import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Payment.css';
import cs from '../../commonStyle.css';

import CurrencyConverter from '../../CurrencyConverter';
import messages from '../../../locale/messages';
import Faq from '/public/SiteIcons/question.svg';

class PaymentDetails extends Component {
  static propTypes = {
    delivery: PropTypes.number,
    currency: PropTypes.string.isRequired,
    dayDifference: PropTypes.number.isRequired,
    discount: PropTypes.number,
    discountType: PropTypes.string,
    priceForDays: PropTypes.number.isRequired,
    serviceFees: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    subtotal: PropTypes.number,
    promoDiscount: PropTypes.number,
    promoLabel: PropTypes.string,
    securityDeposit: PropTypes.number,
    isAverage: PropTypes.number,
    securityDepositStatus: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    readOnlyPromo: PropTypes.bool,
  };

  renderPromoTooltip = () => {
    const { formatMessage } = this.props.intl;

    return (
      <OverlayTrigger
        overlay={
          <Tooltip className={s.tooltip} id="payment-promo-discount-tooltip">
            {formatMessage(messages.promoDiscountTooltip)}
          </Tooltip>
        }
        placement="top"
        delayShow={300}
        delayHide={150}
      >
        <span className={s.promoTooltipIcon}>
          <img src={Faq} className={cx(s.faqImage, 'faqImageRTL')} alt="" />
        </span>
      </OverlayTrigger>
    );
  };

  render() {
    const { delivery, currency, dayDifference, securityDeposit } = this.props;
    const {
      priceForDays,
      serviceFees,
      discount,
      discountType,
      total,
      subtotal,
      promoDiscount,
      promoLabel,
      isAverage,
      securityDepositStatus,
    } = this.props;
    const { formatMessage } = this.props.intl;

    const promoDiscountAmount = Number(promoDiscount) || 0;
    const securityDepositAmount =
      securityDepositStatus == 1 ? Number(securityDeposit) || 0 : 0;
    const displaySubtotal =
      subtotal != null
        ? Number(subtotal)
        : securityDepositAmount > 0
          ? Number(total) - securityDepositAmount
          : Number(total);

    return (
      <>
        <div className={cx(s.tableFlex, cs.commonMediumText)}>
          <div>
            <div className={cx(s.specialPriceText, 'directionLtr')}>
              <CurrencyConverter amount={isAverage} from={currency} />
              {' x'} {dayDifference}{' '}
              {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
            </div>
          </div>
          <div>
            <CurrencyConverter amount={priceForDays} from={currency} />
          </div>
        </div>
        <hr className={cx(s.horizondalLine, s.hrLineSidePanelMargin)} />
        {delivery > 0 && (
          <>
            <h5 className={cx(s.tableFlex, cs.commonMediumText, cs.fontWeightNormal)}>
              <FormattedMessage {...messages.cleaningFee} />
              <CurrencyConverter amount={delivery} from={currency} />
            </h5>
            <hr className={cx(s.horizondalLine, s.hrLineSidePanelMargin)} />
          </>
        )}
        {serviceFees > 0 && (
          <>
            <h6 className={cx(s.tableFlex, cs.commonMediumText, cs.fontWeightNormal)}>
              <FormattedMessage {...messages.serviceFee} />
              <CurrencyConverter amount={serviceFees} from={currency} />
            </h6>
            <hr className={cx(s.horizondalLine, s.hrLineSidePanelMargin)} />
          </>
        )}
        {discount > 0 && (
          <>
            <h5 className={cx(s.tableFlex, cs.commonMediumText, cs.fontWeightNormal)}>
              <span>{discountType}</span>
              <span className={s.discountText}>
                -{' '}
                <CurrencyConverter amount={discount} from={currency} />
              </span>
            </h5>
            <hr className={cx(s.horizondalLine, s.hrLineSidePanelMargin)} />
          </>
        )}
        {promoDiscountAmount > 0 && (
          <>
            <h5 className={cx(s.tableFlex, cs.commonMediumText, cs.fontWeightNormal)}>
              <span>
                {this.renderPromoTooltip()}
                {promoLabel || formatMessage(messages.promoDiscount)}
              </span>
              <span className={s.discountText}>
                -{' '}
                <CurrencyConverter amount={promoDiscountAmount} from={currency} />
              </span>
            </h5>
            <hr className={cx(s.horizondalLine, s.hrLineSidePanelMargin)} />
          </>
        )}
        <h4 className={cx(s.tableFlex, cs.commonContentText, cs.fontWeightMedium)}>
          <FormattedMessage {...messages.subTotal} />
          <CurrencyConverter amount={displaySubtotal} from={currency} />
        </h4>
        <hr className={cx(s.horizondalLine, s.hrLineSidePanelMargin)} />
        {securityDepositAmount > 0 && (
          <>
            <h6 className={cx(s.tableFlex, cs.commonMediumText, cs.fontWeightNormal)}>
              <FormattedMessage {...messages.securityDeposit} />
              <CurrencyConverter amount={securityDepositAmount} from={currency} />
            </h6>
            <hr className={cx(s.horizondalLine, s.hrLineSidePanelMargin)} />
          </>
        )}
        <h4 className={cx(s.tableFlex, cs.commonContentText, cs.fontWeightMedium)}>
          <FormattedMessage {...messages.total} />
          <CurrencyConverter amount={total} from={currency} />
        </h4>
      </>
    );
  }
}

export default injectIntl(withStyles(s)(PaymentDetails));
